import type { schemaType } from '~~/modules/api/rurality/v3/blog/posts/list/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-blogposts.vue'

export const useToSBlogposts = () => {
  const fromBlogPostList = (data: schemaType): propsInterface => {
    const dataPosts: schemaType = JSON.parse(JSON.stringify(data))

    dataPosts.posts.map(item => {
      item.media.img = item.media.img.replace(
        '/blog/',
        'https://www.escapadarural.com/blog/',
      )
      item.media.img2x = item.media.img2x.replace(
        '/blog/',
        'https://www.escapadarural.com/blog/',
      )

      if (item.readingTime) {
        item.readingTime = `${item.readingTime} ${t('components.blog-post.readingTime')}`
      }

      return item
    })
    return {
      posts: dataPosts.posts,
    }
  }

  return {
    fromBlogPostList,
  }
}
